module.exports = __webpack_public_path__ + "images/application/badge-email-single-6a654016.png";